/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react/require-default-props */
import { Modal } from 'antd'
import React, { FC, ReactNode, useEffect, useMemo, useState } from 'react'
import BaseSelector, { BaseSelectorOption } from '.'

type BaseSelectorModalProps<RecordType> = {
 value?: BaseSelectorOption<RecordType>[]
 defaultIds?: any[]
 open?: boolean
 onCancel?: () => void
 hasMore?: boolean
 DataIsLoading?: boolean
 handleSubmit?: (val: BaseSelectorOption<RecordType>[]) => void
 confirmLoading?: boolean
 data?: BaseSelectorOption<RecordType>[]
 buttonDisabled?: boolean
 fetchMore?: () => void
 searchPlaceholder?: string
 type?: 'single' | 'multiple'
 okText?: string
 title?: ReactNode
 onSearch?: (v?: any) => void
 onChange?: (records: BaseSelectorOption<RecordType>[]) => void
 titleNode?: ReactNode
}

const InternalBaseSelectorModal = <RecordType extends object = any>(
 props: BaseSelectorModalProps<RecordType>,
 ref: React.ForwardedRef<HTMLDivElement>,
) => {
 const {
  open,
  onCancel,
  hasMore,
  DataIsLoading,
  handleSubmit,
  confirmLoading,
  buttonDisabled,
  data,
  fetchMore,
  searchPlaceholder = 'Search',
  type = 'single',
  okText,
  title,
  titleNode,
  onSearch,
  onChange,
  defaultIds,
  value,
 } = props

 //  const [selected, setSelected] = useState<BaseSelectorOption<RecordType>[]>()

 const filterData = useMemo((): BaseSelectorOption<any>[] => {
  return data?.filter((v) => !defaultIds?.includes(v.id)) || []
 }, [data, defaultIds])

 //  useEffect(() => {
 //   setSelected((prv) => [...(prv ?? []), ...(defaultSelected ?? [])])
 //  }, [defaultSelected])

 return (
  <Modal
   centered
   confirmLoading={confirmLoading}
   onOk={value?.length ? () => handleSubmit?.(value) : undefined}
   okText={`Apply (${value?.length ?? 0})`}
   className="modal-has-base-selector"
   title={titleNode || title}
   visible={open}
   onCancel={onCancel}
   okButtonProps={{
    disabled: (value?.length ?? 0) === 0,
   }}
  >
   <BaseSelector
    value={value}
    fetchMore={fetchMore}
    onChange={onChange}
    isLoading={DataIsLoading}
    searchPlaceholder={searchPlaceholder}
    onSearch={onSearch}
    hasMore={hasMore}
    type={type}
    options={filterData}
    showEmpty={!DataIsLoading && filterData?.length === 0}
   />
  </Modal>
 )
}

const BaseSelectorModal = React.forwardRef(InternalBaseSelectorModal) as <
 RecordType extends object = any,
>(
 props: React.PropsWithChildren<BaseSelectorModalProps<RecordType>> & {
  ref?: React.Ref<HTMLDivElement>
 },
) => React.ReactElement

export default BaseSelectorModal
